import type { StaffRole } from '@/types/auth.types';

// ============================================================================
// NAVIGATION ICONS
// ============================================================================

export const navIcons = {
  globe: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  currency: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="16" />
      <line x1="8" y1="12" x2="16" y2="12" />
    </svg>
  ),
  languages: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 8l6 6" />
      <path d="M4 14l6-6 2-3" />
      <path d="M2 5h12" />
      <path d="M7 2h1" />
      <path d="M22 22l-5-10-5 10" />
      <path d="M14 18h6" />
    </svg>
  ),
  creditCard: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
      <line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  ),
  building: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
      <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
      <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
      <path d="M10 6h4" />
      <path d="M10 10h4" />
      <path d="M10 14h4" />
      <path d="M10 18h4" />
    </svg>
  ),
  monitor: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
    </svg>
  ),
  chart: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  users: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  userCircle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="10" r="3" />
      <path d="M7 20.66a8 8 0 0 1 10 0" />
    </svg>
  ),
  ticket: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
      <path d="M13 5v2" />
      <path d="M13 17v2" />
      <path d="M13 11v2" />
    </svg>
  ),
  inbox: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </svg>
  ),
  history: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
      <path d="M12 7v5l4 2" />
    </svg>
  ),
  megaphone: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m3 11 18-5v12L3 13v-2z" />
      <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
    </svg>
  ),
  notice: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="16" height="12" x="4" y="6" rx="2" />
      <path d="M8 10h8" />
      <path d="M8 14h5" />
    </svg>
  ),
  star: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  handshake: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m18 8 4 4a1 1 0 0 1 0 1.4l-4.5 4.5a1.5 1.5 0 0 1-2.1 0L12 14" />
      <path d="M12 14 8.5 17.5a1.5 1.5 0 0 1-2.1 0L2 13a1 1 0 0 1 0-1.4l4-4" />
      <path d="m6 8 6 6" />
      <path d="m14 10-2-2" />
    </svg>
  ),
  gift: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 12 20 22 4 22 4 12" />
      <rect x="2" y="7" width="20" height="5" />
      <line x1="12" y1="22" x2="12" y2="7" />
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
    </svg>
  ),
  giftBox: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="8" width="18" height="4" rx="1" />
      <path d="M12 8v13" />
      <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
      <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
    </svg>
  ),
  wallet: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
      <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
      <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
    </svg>
  ),
  percent: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="19" y1="5" x2="5" y2="19" />
      <circle cx="6.5" cy="6.5" r="2.5" />
      <circle cx="17.5" cy="17.5" r="2.5" />
    </svg>
  ),
  receipt: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
      <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
      <path d="M12 17.5v-11" />
    </svg>
  ),
  calculator: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="16" height="20" x="4" y="2" rx="2" />
      <line x1="8" x2="16" y1="6" y2="6" />
      <line x1="16" x2="16" y1="14" y2="18" />
      <path d="M16 10h.01" />
      <path d="M12 10h.01" />
      <path d="M8 10h.01" />
      <path d="M12 14h.01" />
      <path d="M8 14h.01" />
      <path d="M12 18h.01" />
      <path d="M8 18h.01" />
    </svg>
  ),
  plusCircle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="16" />
      <line x1="8" y1="12" x2="16" y2="12" />
    </svg>
  ),
  tag: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
      <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
    </svg>
  ),
  mapPin: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),
  settings: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  fileText: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
      <path d="M10 9H8" />
      <path d="M16 13H8" />
      <path d="M16 17H8" />
    </svg>
  ),
  smartphone: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
      <path d="M12 18h.01" />
    </svg>
  ),
  calendarCoin: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4" />
      <path d="M16 2v4" />
      <path d="M8 2v4" />
      <path d="M3 10h7" />
      <circle cx="16.5" cy="16.5" r="5.5" />
      <path d="M16.5 13.5v6" />
      <path d="M18.5 15h-3.2a1.3 1.3 0 0 0 0 2.6h2.4a1.3 1.3 0 0 1 0 2.6h-3.2" />
    </svg>
  ),
};

// ============================================================================
// NAVIGATION ITEM TYPE
// ============================================================================

export interface NavItem {
  label: string;
  href?: string;
  icon?: React.ReactNode;
  section?: boolean;
}

/**
 * Navigation split into platform-level (global) and country-scoped items.
 * The sidebar renders both groups with a visual separator and an inline
 * country selector between them.
 */
export interface RoleNavigation {
  /** Platform-level items — always visible regardless of country selection */
  global: NavItem[];
  /** Country-scoped items — visible only when a country is selected */
  country: NavItem[];
}

// ============================================================================
// NAVIGATION CONFIG BY ROLE
// ============================================================================

export const navigationByRole: Record<StaffRole, RoleNavigation> = {
  SUPER_ADMIN: {
    global: [
      { label: 'Plataforma', section: true },
      {
        label: 'Estado del servidor',
        href: '/server-monitoring',
        icon: navIcons.monitor,
      },
      { label: 'Monedas', href: '/currencies', icon: navIcons.currency },
      { label: 'Idiomas', href: '/languages', icon: navIcons.languages },
      {
        label: 'Versiones de la app',
        href: '/app-versions',
        icon: navIcons.smartphone,
      },
      { label: 'Parámetros', href: '/settings', icon: navIcons.settings },
      {
        label: 'Documentación',
        href: '/documentacion',
        icon: navIcons.fileText,
      },
    ],
    country: [
      {
        label: 'Monitoreo operativo',
        href: '/monitoring',
        icon: navIcons.chart,
      },
      {
        label: 'Tickets de soporte',
        href: '/support-tickets',
        icon: navIcons.ticket,
      },
      {
        label: 'Reembolsos',
        href: '/refund-requests',
        icon: navIcons.creditCard,
      },
      {
        label: 'Solicitudes de comercios',
        href: '/leads',
        icon: navIcons.inbox,
      },
      {
        label: 'Comercios recomendados',
        href: '/recommendations',
        icon: navIcons.inbox,
      },
      {
        label: 'Asesores comerciales',
        href: '/advisor-leads',
        icon: navIcons.handshake,
      },
      { label: 'Colaboradores', href: '/staff', icon: navIcons.users },
      { label: 'Compañías', href: '/companies', icon: navIcons.building },
      { label: 'Clientes', href: '/customers', icon: navIcons.userCircle },
      {
        label: 'Organizaciones',
        href: '/organizations',
        icon: navIcons.mapPin,
      },
      {
        label: 'Creadores de contenido',
        href: '/content-creators',
        icon: navIcons.star,
      },
      {
        label: 'Ajustes del país',
        href: '/country-config',
        icon: navIcons.settings,
      },
      { label: 'Finanzas', section: true },
      {
        label: 'Resumen financiero',
        href: '/finance-dashboard',
        icon: navIcons.chart,
      },
      {
        label: 'Transacciones',
        href: '/finance-payments',
        icon: navIcons.creditCard,
      },
      {
        label: 'Pagos a tiendas',
        href: '/finance-store-payouts',
        icon: navIcons.building,
      },
      {
        label: 'Pagos a creadores',
        href: '/finance-influencer-payouts',
        icon: navIcons.wallet,
      },
      {
        label: 'Pagos a asesores',
        href: '/commercial-advisors',
        icon: navIcons.handshake,
      },
      {
        label: 'Pagos programados',
        href: '/finance/scheduled-payouts',
        icon: navIcons.calendarCoin,
      },
      {
        label: 'Cuentas bancarias',
        href: '/finance-bank-accounts',
        icon: navIcons.building,
      },
      {
        label: 'Suscripciones',
        href: '/finance-subscriptions',
        icon: navIcons.receipt,
      },
      {
        label: 'Billeteras',
        href: '/finance-wallets',
        icon: navIcons.wallet,
      },
      {
        label: 'Devoluciones de saldo',
        href: '/finance-wallet-withdrawals',
        icon: navIcons.wallet,
      },
      {
        label: 'Reportes financieros',
        href: '/finance-reports',
        icon: navIcons.fileText,
      },
      { label: 'Marketing', section: true },
      { label: 'Regalos', href: '/gifts', icon: navIcons.gift },
      { label: 'Publicidad', href: '/advertising', icon: navIcons.megaphone },
      { label: 'Avisos', href: '/in-app-notices', icon: navIcons.notice },
      { label: 'Estadísticas', href: '/statistics', icon: navIcons.chart },
      {
        label: 'Puntos y cashback',
        href: '/points-cashback',
        icon: navIcons.percent,
      },
      {
        label: 'Referidos',
        href: '/referral-report',
        icon: navIcons.handshake,
      },
    ],
  },
  SUPPORT_LEAD: {
    global: [
      {
        label: 'Documentación',
        href: '/documentacion',
        icon: navIcons.fileText,
      },
    ],
    country: [
      {
        label: 'Tickets de soporte',
        href: '/support-tickets',
        icon: navIcons.ticket,
      },
      {
        label: 'Referidos',
        href: '/referral-report',
        icon: navIcons.handshake,
      },
      {
        label: 'Reembolsos',
        href: '/refund-requests',
        icon: navIcons.creditCard,
      },
      {
        label: 'Solicitudes de comercios',
        href: '/leads',
        icon: navIcons.inbox,
      },
      {
        label: 'Comercios recomendados',
        href: '/recommendations',
        icon: navIcons.inbox,
      },
      {
        label: 'Asesores comerciales',
        href: '/advisor-leads',
        icon: navIcons.handshake,
      },
      {
        label: 'Cuentas bancarias',
        href: '/finance-bank-accounts',
        icon: navIcons.building,
      },
      {
        label: 'Agentes de soporte',
        href: '/support-agents',
        icon: navIcons.users,
      },
      {
        label: 'Pagos a asesores',
        href: '/commercial-advisors',
        icon: navIcons.handshake,
      },
      {
        label: 'Compañías',
        href: '/support-companies',
        icon: navIcons.building,
      },
      { label: 'Clientes', href: '/customers', icon: navIcons.userCircle },
      {
        label: 'Mis organizaciones',
        href: '/organizations',
        icon: navIcons.mapPin,
      },
      {
        label: 'Monitoreo operativo',
        href: '/monitoring',
        icon: navIcons.chart,
      },
      { label: 'Reportes', href: '/reports', icon: navIcons.fileText },
    ],
  },
  SUPPORT_AGENT: {
    global: [
      {
        label: 'Documentación',
        href: '/documentacion',
        icon: navIcons.fileText,
      },
    ],
    country: [
      { label: 'Mis tickets', href: '/support-tickets', icon: navIcons.ticket },
      {
        label: 'Reembolsos',
        href: '/refund-requests',
        icon: navIcons.creditCard,
      },
      { label: 'Solicitudes de comercios', href: '/leads', icon: navIcons.inbox },
      {
        label: 'Comercios recomendados',
        href: '/recommendations',
        icon: navIcons.inbox,
      },
      {
        label: 'Asesores comerciales',
        href: '/advisor-leads',
        icon: navIcons.handshake,
      },
      {
        label: 'Mis compañías',
        href: '/my-companies',
        icon: navIcons.building,
      },
      {
        label: 'Mis organizaciones',
        href: '/organizations',
        icon: navIcons.mapPin,
      },
      {
        label: 'Cuentas bancarias',
        href: '/finance-bank-accounts',
        icon: navIcons.building,
      },
      {
        label: 'Mis creadores',
        href: '/content-creators',
        icon: navIcons.star,
      },
      { label: 'Mis reportes', href: '/my-reports', icon: navIcons.fileText },
    ],
  },
  MARKETING: {
    global: [
      {
        label: 'Documentación',
        href: '/documentacion',
        icon: navIcons.fileText,
      },
    ],
    country: [
      {
        label: 'Organizaciones',
        href: '/organizations',
        icon: navIcons.mapPin,
      },
      {
        label: 'Creadores de contenido',
        href: '/content-creators',
        icon: navIcons.star,
      },
      { label: 'Regalos', href: '/gifts', icon: navIcons.gift },
      { label: 'Publicidad', href: '/advertising', icon: navIcons.megaphone },
      { label: 'Avisos', href: '/in-app-notices', icon: navIcons.notice },
      { label: 'Estadísticas', href: '/statistics', icon: navIcons.chart },
      {
        label: 'Puntos y cashback',
        href: '/points-cashback',
        icon: navIcons.percent,
      },
    ],
  },
  FINANCE: {
    global: [
      {
        label: 'Documentación',
        href: '/documentacion',
        icon: navIcons.fileText,
      },
    ],
    country: [
      {
        label: 'Resumen financiero',
        href: '/finance-dashboard',
        icon: navIcons.chart,
      },
      {
        label: 'Compañías',
        href: '/finance-companies',
        icon: navIcons.building,
      },
      {
        label: 'Referidos',
        href: '/referral-report',
        icon: navIcons.handshake,
      },
      {
        label: 'Ingresos por creador',
        href: '/finance-creators',
        icon: navIcons.star,
      },
      {
        label: 'Reembolsos',
        href: '/refund-requests',
        icon: navIcons.creditCard,
      },
      {
        label: 'Transacciones',
        href: '/finance-payments',
        icon: navIcons.creditCard,
      },
      {
        label: 'Pagos a tiendas',
        href: '/finance-store-payouts',
        icon: navIcons.building,
      },
      {
        label: 'Pagos a creadores',
        href: '/finance-influencer-payouts',
        icon: navIcons.wallet,
      },
      {
        label: 'Pagos a asesores',
        href: '/commercial-advisors',
        icon: navIcons.handshake,
      },
      {
        label: 'Pagos programados',
        href: '/finance/scheduled-payouts',
        icon: navIcons.calendarCoin,
      },
      {
        label: 'Cuentas bancarias',
        href: '/finance-bank-accounts',
        icon: navIcons.building,
      },
      {
        label: 'Suscripciones',
        href: '/finance-subscriptions',
        icon: navIcons.receipt,
      },
      {
        label: 'Billeteras',
        href: '/finance-wallets',
        icon: navIcons.wallet,
      },
      {
        label: 'Devoluciones de saldo',
        href: '/finance-wallet-withdrawals',
        icon: navIcons.wallet,
      },
      {
        label: 'Reportes financieros',
        href: '/finance-reports',
        icon: navIcons.fileText,
      },
      { label: 'Configuración fiscal', section: true },
      { label: 'Impuestos', href: '/taxes', icon: navIcons.calculator },
      {
        label: 'Tarifas de servicio',
        href: '/service-fees',
        icon: navIcons.percent,
      },
    ],
  },
  SALES_MANAGER: {
    global: [
      {
        label: 'Mis compañías',
        href: '/my-companies',
        icon: navIcons.building,
      },
      {
        label: 'Mis organizaciones',
        href: '/organizations',
        icon: navIcons.mapPin,
      },
      {
        label: 'Cuentas bancarias',
        href: '/finance-bank-accounts',
        icon: navIcons.building,
      },
      {
        label: 'Documentación',
        href: '/documentacion',
        icon: navIcons.fileText,
      },
    ],
    country: [],
  },
  // Asesor Comercial externo: capta/acompaña comercios y comisiona sobre
  // el ingreso de plataforma de sus empresas asignadas (CompanyAdvisor).
  // Navegación mínima Fase 1 — las vistas de comisiones y pagos se
  // añaden en fases 2-3 (docs/PLAN_ASESOR_COMERCIAL_2026_07_21.md del backend).
  COMMERCIAL_ADVISOR: {
    global: [
      {
        label: 'Mis comercios',
        href: '/my-companies',
        icon: navIcons.building,
      },
      {
        label: 'Mis comisiones',
        href: '/my-advisor-commissions',
        icon: navIcons.percent,
      },
      {
        label: 'Mis pagos',
        href: '/my-advisor-payouts',
        icon: navIcons.creditCard,
      },
      {
        label: 'Documentación',
        href: '/documentacion',
        icon: navIcons.fileText,
      },
    ],
    country: [],
  },
};

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

/**
 * Get navigation config for a specific role
 */
export function getNavigationForRole(role: StaffRole): RoleNavigation {
  return navigationByRole[role] || { global: [], country: [] };
}

/**
 * Get the first navigation item for a role (excluding section headers).
 * Checks global items first, then country items.
 */
export function getFirstNavItem(role: StaffRole): NavItem | undefined {
  const nav = navigationByRole[role];
  if (!nav) return undefined;
  return (
    nav.global.find((item) => !item.section) ||
    nav.country.find((item) => !item.section)
  );
}

/**
 * Get the default route for a role (first item's href)
 */
export function getDefaultRouteForRole(role: StaffRole): string {
  const firstItem = getFirstNavItem(role);
  return firstItem?.href || '/';
}

/**
 * Default route for SUPER_ADMIN (used for root redirect before auth)
 */
export const DEFAULT_DASHBOARD_ROUTE =
  getFirstNavItem('SUPER_ADMIN')?.href || '/currencies';
